import { useEffect } from 'react';
import {AppEventsLogger} from 'react-native-fbsdk-next';

import analytics from '@react-native-firebase/analytics';
import {NativeStackScreenProps} from 'react-native-screens/lib/typescript/native-stack/types';
import {RootStackParamList} from '../../../dtos/RoutesDTO';
import {SubRegionsList} from '../../../components/shared/RegionsList/Subregions';
import { Platform } from 'react-native';
import {addInAppTrigger} from '../../../lib/pushMessaging';

type ScreenProps = NativeStackScreenProps<RootStackParamList, 'SubRegions'>;

export function SubRegions({navigation, route}: ScreenProps) {
  const regiao = route.params;

  useEffect(() => {
    if(Platform.OS !== "web"){
addInAppTrigger('screen', 'fuel_cities');
    }
    
  }, [])

  async function handleRegion(cidade: string) {
    await analytics().logSelectContent({
      content_type: 'regiao - ' + regiao.data._id,
      item_id: regiao.data._id,
    });
    navigation.push('ListagemPostos', {
      cidade,
      tipo: regiao.tipo,
      localidade: regiao.data._id,
      isUserLocation: false,
    });
    AppEventsLogger.logEvent('clique_cidade', {cidade});
  }

  return (
    <SubRegionsList
      action={handleRegion}
      cidades={regiao.data.cidades}
      stateId={regiao.data._id}
      tipo={regiao.tipo}
    />
  );
}
